import React, { useState } from "react";
import { Modal, Button, Form, Alert, Badge } from "react-bootstrap";
import api from "../../api";
import { toast } from "react-toastify";
import "../../pages/tasks/TicketModalTheme.css";

// Phase 4B, §14/§29. Approve / Reject / Changes Requested on one specific
// pending stage. The backend is the sole authority on remark requirements
// and on whether this caller is actually the resolved approver — this
// dialog only shows the backend's own rule/error back to the user clearly.
export default function TaskApprovalDecisionDialog({ show, onHide, requestId, stage, taskTitle, onDecided }) {
  const [action, setAction] = useState(null); // 'APPROVE' | 'REJECT' | 'CHANGES_REQUESTED'
  const [remarks, setRemarks] = useState("");
  const [saving, setSaving] = useState(false);

  const chooseAction = (a) => { setAction(a); setRemarks(""); };

  const submit = async () => {
    setSaving(true);
    try {
      await api.post(`/task-approval-requests/${requestId}/stages/${stage.id}/decision`, { action, remarks: remarks || undefined });
      toast.success(`Decision recorded: ${action.replace("_", " ")}`);
      onDecided?.();
      onHide();
    } catch (err) {
      const data = err.response?.data;
      if (data?.code === "TASK_APPROVAL_REMARK_REQUIRED") toast.error("Remarks are required for this decision.");
      else if (data?.code === "TASK_APPROVAL_SELF_NOT_ALLOWED") toast.error("You cannot decide on your own approval request.");
      else if (data?.code === "TASK_APPROVAL_STAGE_NOT_PENDING" || data?.code === "TASK_APPROVAL_REQUEST_NOT_PENDING") toast.error("This stage has already been decided or is no longer pending — refresh and try again.");
      else if (data?.code === "TASK_APPROVAL_ACCESS_DENIED") toast.error("You are not the resolved approver for this stage.");
      else toast.error(data?.message || "Failed to record decision");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered className="ticket-modal-theme">
      <Modal.Header closeButton><Modal.Title>Approval Decision</Modal.Title></Modal.Header>
      <Modal.Body>
        <div className="small text-muted mb-2">Task: <strong>{taskTitle}</strong></div>
        <div className="small text-muted mb-3">Stage: <strong>{stage?.stage_name}</strong> (#{stage?.stage_order})</div>

        {!action ? (
          <div className="d-flex gap-2">
            <Button variant="primary" onClick={() => chooseAction("APPROVE")}>Approve</Button>
            <Button variant="outline-warning" onClick={() => chooseAction("CHANGES_REQUESTED")}>Request Changes</Button>
            <Button variant="outline-danger" onClick={() => chooseAction("REJECT")}>Reject</Button>
          </div>
        ) : (
          <>
            <Alert variant={action === "APPROVE" ? "success" : action === "REJECT" ? "danger" : "warning"} className="small">
              Confirm: <strong>{action.replace("_", " ")}</strong> this stage.
            </Alert>
            <Form.Label className="small">
              Remarks {action !== "APPROVE" && <Badge bg="secondary">Required</Badge>}
            </Form.Label>
            <Form.Control as="textarea" rows={3} value={remarks} onChange={(e) => setRemarks(e.target.value)} />
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        {action && <Button variant="outline-secondary" onClick={() => setAction(null)}>Back</Button>}
        <Button variant="outline-secondary" onClick={onHide}>Cancel</Button>
        {action && <Button variant="primary" disabled={saving} onClick={submit}>{saving ? "Submitting..." : "Confirm"}</Button>}
      </Modal.Footer>
    </Modal>
  );
}
